/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as StudentPortalIndexRouteImport } from './routes/student-portal/index'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as CertificationLevelsIndexRouteImport } from './routes/certification-levels/index'
import { Route as VerifyCodeRouteImport } from './routes/verify/$code'
import { Route as StudentPortalContactIdRouteImport } from './routes/student-portal/$contactId'
import { Route as ClientMilestoneTokenRouteImport } from './routes/client-milestone.$token'
import { Route as AuthenticatedCompanyRouteRouteImport } from './routes/_authenticated/company/route'
import { Route as AuthenticatedUserManagementIndexRouteImport } from './routes/_authenticated/user-management/index'
import { Route as AuthenticatedTeacherDashboardIndexRouteImport } from './routes/_authenticated/teacher-dashboard/index'
import { Route as AuthenticatedStaffIndexRouteImport } from './routes/_authenticated/staff/index'
import { Route as AuthenticatedShopIndexRouteImport } from './routes/_authenticated/shop/index'
import { Route as AuthenticatedProjectsIndexRouteImport } from './routes/_authenticated/projects/index'
import { Route as AuthenticatedProductsIndexRouteImport } from './routes/_authenticated/products/index'
import { Route as AuthenticatedFairQuoteIndexRouteImport } from './routes/_authenticated/fair-quote/index'
import { Route as AuthenticatedEntitiesIndexRouteImport } from './routes/_authenticated/entities/index'
import { Route as AuthenticatedDashboardIndexRouteImport } from './routes/_authenticated/dashboard/index'
import { Route as AuthenticatedCoursesIndexRouteImport } from './routes/_authenticated/courses/index'
import { Route as AuthenticatedContactsIndexRouteImport } from './routes/_authenticated/contacts/index'
import { Route as AuthenticatedCompanyIndexRouteImport } from './routes/_authenticated/company/index'
import { Route as AuthenticatedColorsIndexRouteImport } from './routes/_authenticated/colors/index'
import { Route as AuthenticatedCertificationDefinitionsIndexRouteImport } from './routes/_authenticated/certification-definitions/index'
import { Route as AuthenticatedCalendarIndexRouteImport } from './routes/_authenticated/calendar/index'
import { Route as AuthenticatedApplicatorProfilesIndexRouteImport } from './routes/_authenticated/applicator-profiles/index'
import { Route as EnrollCourseIdSessionIdRouteImport } from './routes/enroll/$courseId.$sessionId'
import { Route as CertificationsPublicContactIdRouteImport } from './routes/certifications/public/$contactId'
import { Route as AuthenticatedStaffStaffIdRouteImport } from './routes/_authenticated/staff/$staffId'
import { Route as AuthenticatedShopProductIdRouteImport } from './routes/_authenticated/shop/$productId'
import { Route as AuthenticatedProjectsProjectSlugRouteImport } from './routes/_authenticated/projects/$projectSlug'
import { Route as AuthenticatedProductsProductIdRouteImport } from './routes/_authenticated/products/$productId'
import { Route as AuthenticatedFairQuoteProjectSlugRouteImport } from './routes/_authenticated/fair-quote/$projectSlug'
import { Route as AuthenticatedEntitiesEntityIdRouteImport } from './routes/_authenticated/entities/$entityId'
import { Route as AuthenticatedCoursesCourseIdRouteImport } from './routes/_authenticated/courses/$courseId'
import { Route as AuthenticatedContactsContactIdRouteImport } from './routes/_authenticated/contacts/$contactId'
import { Route as AuthenticatedCompanyTaskGenRouteImport } from './routes/_authenticated/company/task-gen'
import { Route as AuthenticatedCompanyRoomCalculationRouteImport } from './routes/_authenticated/company/room-calculation'
import { Route as AuthenticatedCompanyQuoteRouteImport } from './routes/_authenticated/company/quote'
import { Route as AuthenticatedCompanyMilestonesRouteImport } from './routes/_authenticated/company/milestones'
import { Route as AuthenticatedApplicatorProfilesProfileIdRouteImport } from './routes/_authenticated/applicator-profiles/$profileId'
import { Route as AuthenticatedProjectsProjectSlugIndexRouteImport } from './routes/_authenticated/projects/$projectSlug/index'
import { Route as AuthenticatedFairQuoteProjectSlugIndexRouteImport } from './routes/_authenticated/fair-quote/$projectSlug/index'
import { Route as AuthenticatedCompanyStaffIndexRouteImport } from './routes/_authenticated/company/staff/index'
import { Route as AuthenticatedCompanyStaffStaffIdRouteImport } from './routes/_authenticated/company/staff/$staffId'
import { Route as AuthenticatedProjectsProjectSlugSectionsSectionSlugRouteImport } from './routes/_authenticated/projects/$projectSlug/sections/$sectionSlug'
import { Route as AuthenticatedFairQuoteProjectSlugSectionsSectionSlugRouteImport } from './routes/_authenticated/fair-quote/$projectSlug/sections/$sectionSlug'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const StudentPortalIndexRoute = StudentPortalIndexRouteImport.update({
  id: '/student-portal/',
  path: '/student-portal/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRouteImport,
} as any)
const CertificationLevelsIndexRoute =
  CertificationLevelsIndexRouteImport.update({
    id: '/certification-levels/',
    path: '/certification-levels/',
    getParentRoute: () => rootRouteImport,
  } as any)
const VerifyCodeRoute = VerifyCodeRouteImport.update({
  id: '/verify/$code',
  path: '/verify/$code',
  getParentRoute: () => rootRouteImport,
} as any)
const StudentPortalContactIdRoute = StudentPortalContactIdRouteImport.update({
  id: '/student-portal/$contactId',
  path: '/student-portal/$contactId',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientMilestoneTokenRoute = ClientMilestoneTokenRouteImport.update({
  id: '/client-milestone/$token',
  path: '/client-milestone/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedCompanyRouteRoute =
  AuthenticatedCompanyRouteRouteImport.update({
    id: '/company',
    path: '/company',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUserManagementIndexRoute =
  AuthenticatedUserManagementIndexRouteImport.update({
    id: '/user-management/',
    path: '/user-management/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTeacherDashboardIndexRoute =
  AuthenticatedTeacherDashboardIndexRouteImport.update({
    id: '/teacher-dashboard/',
    path: '/teacher-dashboard/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedStaffIndexRoute = AuthenticatedStaffIndexRouteImport.update({
  id: '/staff/',
  path: '/staff/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedShopIndexRoute = AuthenticatedShopIndexRouteImport.update({
  id: '/shop/',
  path: '/shop/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedProjectsIndexRoute =
  AuthenticatedProjectsIndexRouteImport.update({
    id: '/projects/',
    path: '/projects/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProductsIndexRoute =
  AuthenticatedProductsIndexRouteImport.update({
    id: '/products/',
    path: '/products/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFairQuoteIndexRoute =
  AuthenticatedFairQuoteIndexRouteImport.update({
    id: '/fair-quote/',
    path: '/fair-quote/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEntitiesIndexRoute =
  AuthenticatedEntitiesIndexRouteImport.update({
    id: '/entities/',
    path: '/entities/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDashboardIndexRoute =
  AuthenticatedDashboardIndexRouteImport.update({
    id: '/dashboard/',
    path: '/dashboard/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCoursesIndexRoute =
  AuthenticatedCoursesIndexRouteImport.update({
    id: '/courses/',
    path: '/courses/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedContactsIndexRoute =
  AuthenticatedContactsIndexRouteImport.update({
    id: '/contacts/',
    path: '/contacts/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCompanyIndexRoute =
  AuthenticatedCompanyIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedCompanyRouteRoute,
  } as any)
const AuthenticatedColorsIndexRoute =
  AuthenticatedColorsIndexRouteImport.update({
    id: '/colors/',
    path: '/colors/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCertificationDefinitionsIndexRoute =
  AuthenticatedCertificationDefinitionsIndexRouteImport.update({
    id: '/certification-definitions/',
    path: '/certification-definitions/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCalendarIndexRoute =
  AuthenticatedCalendarIndexRouteImport.update({
    id: '/calendar/',
    path: '/calendar/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedApplicatorProfilesIndexRoute =
  AuthenticatedApplicatorProfilesIndexRouteImport.update({
    id: '/applicator-profiles/',
    path: '/applicator-profiles/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const EnrollCourseIdSessionIdRoute = EnrollCourseIdSessionIdRouteImport.update({
  id: '/enroll/$courseId/$sessionId',
  path: '/enroll/$courseId/$sessionId',
  getParentRoute: () => rootRouteImport,
} as any)
const CertificationsPublicContactIdRoute =
  CertificationsPublicContactIdRouteImport.update({
    id: '/certifications/public/$contactId',
    path: '/certifications/public/$contactId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthenticatedStaffStaffIdRoute =
  AuthenticatedStaffStaffIdRouteImport.update({
    id: '/staff/$staffId',
    path: '/staff/$staffId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedShopProductIdRoute =
  AuthenticatedShopProductIdRouteImport.update({
    id: '/shop/$productId',
    path: '/shop/$productId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProjectsProjectSlugRoute =
  AuthenticatedProjectsProjectSlugRouteImport.update({
    id: '/projects/$projectSlug',
    path: '/projects/$projectSlug',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProductsProductIdRoute =
  AuthenticatedProductsProductIdRouteImport.update({
    id: '/products/$productId',
    path: '/products/$productId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFairQuoteProjectSlugRoute =
  AuthenticatedFairQuoteProjectSlugRouteImport.update({
    id: '/fair-quote/$projectSlug',
    path: '/fair-quote/$projectSlug',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEntitiesEntityIdRoute =
  AuthenticatedEntitiesEntityIdRouteImport.update({
    id: '/entities/$entityId',
    path: '/entities/$entityId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCoursesCourseIdRoute =
  AuthenticatedCoursesCourseIdRouteImport.update({
    id: '/courses/$courseId',
    path: '/courses/$courseId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedContactsContactIdRoute =
  AuthenticatedContactsContactIdRouteImport.update({
    id: '/contacts/$contactId',
    path: '/contacts/$contactId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCompanyTaskGenRoute =
  AuthenticatedCompanyTaskGenRouteImport.update({
    id: '/task-gen',
    path: '/task-gen',
    getParentRoute: () => AuthenticatedCompanyRouteRoute,
  } as any)
const AuthenticatedCompanyRoomCalculationRoute =
  AuthenticatedCompanyRoomCalculationRouteImport.update({
    id: '/room-calculation',
    path: '/room-calculation',
    getParentRoute: () => AuthenticatedCompanyRouteRoute,
  } as any)
const AuthenticatedCompanyQuoteRoute =
  AuthenticatedCompanyQuoteRouteImport.update({
    id: '/quote',
    path: '/quote',
    getParentRoute: () => AuthenticatedCompanyRouteRoute,
  } as any)
const AuthenticatedCompanyMilestonesRoute =
  AuthenticatedCompanyMilestonesRouteImport.update({
    id: '/milestones',
    path: '/milestones',
    getParentRoute: () => AuthenticatedCompanyRouteRoute,
  } as any)
const AuthenticatedApplicatorProfilesProfileIdRoute =
  AuthenticatedApplicatorProfilesProfileIdRouteImport.update({
    id: '/applicator-profiles/$profileId',
    path: '/applicator-profiles/$profileId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProjectsProjectSlugIndexRoute =
  AuthenticatedProjectsProjectSlugIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedProjectsProjectSlugRoute,
  } as any)
const AuthenticatedFairQuoteProjectSlugIndexRoute =
  AuthenticatedFairQuoteProjectSlugIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedFairQuoteProjectSlugRoute,
  } as any)
const AuthenticatedCompanyStaffIndexRoute =
  AuthenticatedCompanyStaffIndexRouteImport.update({
    id: '/staff/',
    path: '/staff/',
    getParentRoute: () => AuthenticatedCompanyRouteRoute,
  } as any)
const AuthenticatedCompanyStaffStaffIdRoute =
  AuthenticatedCompanyStaffStaffIdRouteImport.update({
    id: '/staff/$staffId',
    path: '/staff/$staffId',
    getParentRoute: () => AuthenticatedCompanyRouteRoute,
  } as any)
const AuthenticatedProjectsProjectSlugSectionsSectionSlugRoute =
  AuthenticatedProjectsProjectSlugSectionsSectionSlugRouteImport.update({
    id: '/sections/$sectionSlug',
    path: '/sections/$sectionSlug',
    getParentRoute: () => AuthenticatedProjectsProjectSlugRoute,
  } as any)
const AuthenticatedFairQuoteProjectSlugSectionsSectionSlugRoute =
  AuthenticatedFairQuoteProjectSlugSectionsSectionSlugRouteImport.update({
    id: '/sections/$sectionSlug',
    path: '/sections/$sectionSlug',
    getParentRoute: () => AuthenticatedFairQuoteProjectSlugRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/company': typeof AuthenticatedCompanyRouteRouteWithChildren
  '/client-milestone/$token': typeof ClientMilestoneTokenRoute
  '/student-portal/$contactId': typeof StudentPortalContactIdRoute
  '/verify/$code': typeof VerifyCodeRoute
  '/certification-levels/': typeof CertificationLevelsIndexRoute
  '/login/': typeof LoginIndexRoute
  '/student-portal/': typeof StudentPortalIndexRoute
  '/applicator-profiles/$profileId': typeof AuthenticatedApplicatorProfilesProfileIdRoute
  '/company/milestones': typeof AuthenticatedCompanyMilestonesRoute
  '/company/quote': typeof AuthenticatedCompanyQuoteRoute
  '/company/room-calculation': typeof AuthenticatedCompanyRoomCalculationRoute
  '/company/task-gen': typeof AuthenticatedCompanyTaskGenRoute
  '/contacts/$contactId': typeof AuthenticatedContactsContactIdRoute
  '/courses/$courseId': typeof AuthenticatedCoursesCourseIdRoute
  '/entities/$entityId': typeof AuthenticatedEntitiesEntityIdRoute
  '/fair-quote/$projectSlug': typeof AuthenticatedFairQuoteProjectSlugRouteWithChildren
  '/products/$productId': typeof AuthenticatedProductsProductIdRoute
  '/projects/$projectSlug': typeof AuthenticatedProjectsProjectSlugRouteWithChildren
  '/shop/$productId': typeof AuthenticatedShopProductIdRoute
  '/staff/$staffId': typeof AuthenticatedStaffStaffIdRoute
  '/certifications/public/$contactId': typeof CertificationsPublicContactIdRoute
  '/enroll/$courseId/$sessionId': typeof EnrollCourseIdSessionIdRoute
  '/applicator-profiles/': typeof AuthenticatedApplicatorProfilesIndexRoute
  '/calendar/': typeof AuthenticatedCalendarIndexRoute
  '/certification-definitions/': typeof AuthenticatedCertificationDefinitionsIndexRoute
  '/colors/': typeof AuthenticatedColorsIndexRoute
  '/company/': typeof AuthenticatedCompanyIndexRoute
  '/contacts/': typeof AuthenticatedContactsIndexRoute
  '/courses/': typeof AuthenticatedCoursesIndexRoute
  '/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/entities/': typeof AuthenticatedEntitiesIndexRoute
  '/fair-quote/': typeof AuthenticatedFairQuoteIndexRoute
  '/products/': typeof AuthenticatedProductsIndexRoute
  '/projects/': typeof AuthenticatedProjectsIndexRoute
  '/shop/': typeof AuthenticatedShopIndexRoute
  '/staff/': typeof AuthenticatedStaffIndexRoute
  '/teacher-dashboard/': typeof AuthenticatedTeacherDashboardIndexRoute
  '/user-management/': typeof AuthenticatedUserManagementIndexRoute
  '/company/staff/$staffId': typeof AuthenticatedCompanyStaffStaffIdRoute
  '/company/staff/': typeof AuthenticatedCompanyStaffIndexRoute
  '/fair-quote/$projectSlug/': typeof AuthenticatedFairQuoteProjectSlugIndexRoute
  '/projects/$projectSlug/': typeof AuthenticatedProjectsProjectSlugIndexRoute
  '/fair-quote/$projectSlug/sections/$sectionSlug': typeof AuthenticatedFairQuoteProjectSlugSectionsSectionSlugRoute
  '/projects/$projectSlug/sections/$sectionSlug': typeof AuthenticatedProjectsProjectSlugSectionsSectionSlugRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/client-milestone/$token': typeof ClientMilestoneTokenRoute
  '/student-portal/$contactId': typeof StudentPortalContactIdRoute
  '/verify/$code': typeof VerifyCodeRoute
  '/certification-levels': typeof CertificationLevelsIndexRoute
  '/login': typeof LoginIndexRoute
  '/student-portal': typeof StudentPortalIndexRoute
  '/applicator-profiles/$profileId': typeof AuthenticatedApplicatorProfilesProfileIdRoute
  '/company/milestones': typeof AuthenticatedCompanyMilestonesRoute
  '/company/quote': typeof AuthenticatedCompanyQuoteRoute
  '/company/room-calculation': typeof AuthenticatedCompanyRoomCalculationRoute
  '/company/task-gen': typeof AuthenticatedCompanyTaskGenRoute
  '/contacts/$contactId': typeof AuthenticatedContactsContactIdRoute
  '/courses/$courseId': typeof AuthenticatedCoursesCourseIdRoute
  '/entities/$entityId': typeof AuthenticatedEntitiesEntityIdRoute
  '/products/$productId': typeof AuthenticatedProductsProductIdRoute
  '/shop/$productId': typeof AuthenticatedShopProductIdRoute
  '/staff/$staffId': typeof AuthenticatedStaffStaffIdRoute
  '/certifications/public/$contactId': typeof CertificationsPublicContactIdRoute
  '/enroll/$courseId/$sessionId': typeof EnrollCourseIdSessionIdRoute
  '/applicator-profiles': typeof AuthenticatedApplicatorProfilesIndexRoute
  '/calendar': typeof AuthenticatedCalendarIndexRoute
  '/certification-definitions': typeof AuthenticatedCertificationDefinitionsIndexRoute
  '/colors': typeof AuthenticatedColorsIndexRoute
  '/company': typeof AuthenticatedCompanyIndexRoute
  '/contacts': typeof AuthenticatedContactsIndexRoute
  '/courses': typeof AuthenticatedCoursesIndexRoute
  '/dashboard': typeof AuthenticatedDashboardIndexRoute
  '/entities': typeof AuthenticatedEntitiesIndexRoute
  '/fair-quote': typeof AuthenticatedFairQuoteIndexRoute
  '/products': typeof AuthenticatedProductsIndexRoute
  '/projects': typeof AuthenticatedProjectsIndexRoute
  '/shop': typeof AuthenticatedShopIndexRoute
  '/staff': typeof AuthenticatedStaffIndexRoute
  '/teacher-dashboard': typeof AuthenticatedTeacherDashboardIndexRoute
  '/user-management': typeof AuthenticatedUserManagementIndexRoute
  '/company/staff/$staffId': typeof AuthenticatedCompanyStaffStaffIdRoute
  '/company/staff': typeof AuthenticatedCompanyStaffIndexRoute
  '/fair-quote/$projectSlug': typeof AuthenticatedFairQuoteProjectSlugIndexRoute
  '/projects/$projectSlug': typeof AuthenticatedProjectsProjectSlugIndexRoute
  '/fair-quote/$projectSlug/sections/$sectionSlug': typeof AuthenticatedFairQuoteProjectSlugSectionsSectionSlugRoute
  '/projects/$projectSlug/sections/$sectionSlug': typeof AuthenticatedProjectsProjectSlugSectionsSectionSlugRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_authenticated/company': typeof AuthenticatedCompanyRouteRouteWithChildren
  '/client-milestone/$token': typeof ClientMilestoneTokenRoute
  '/student-portal/$contactId': typeof StudentPortalContactIdRoute
  '/verify/$code': typeof VerifyCodeRoute
  '/certification-levels/': typeof CertificationLevelsIndexRoute
  '/login/': typeof LoginIndexRoute
  '/student-portal/': typeof StudentPortalIndexRoute
  '/_authenticated/applicator-profiles/$profileId': typeof AuthenticatedApplicatorProfilesProfileIdRoute
  '/_authenticated/company/milestones': typeof AuthenticatedCompanyMilestonesRoute
  '/_authenticated/company/quote': typeof AuthenticatedCompanyQuoteRoute
  '/_authenticated/company/room-calculation': typeof AuthenticatedCompanyRoomCalculationRoute
  '/_authenticated/company/task-gen': typeof AuthenticatedCompanyTaskGenRoute
  '/_authenticated/contacts/$contactId': typeof AuthenticatedContactsContactIdRoute
  '/_authenticated/courses/$courseId': typeof AuthenticatedCoursesCourseIdRoute
  '/_authenticated/entities/$entityId': typeof AuthenticatedEntitiesEntityIdRoute
  '/_authenticated/fair-quote/$projectSlug': typeof AuthenticatedFairQuoteProjectSlugRouteWithChildren
  '/_authenticated/products/$productId': typeof AuthenticatedProductsProductIdRoute
  '/_authenticated/projects/$projectSlug': typeof AuthenticatedProjectsProjectSlugRouteWithChildren
  '/_authenticated/shop/$productId': typeof AuthenticatedShopProductIdRoute
  '/_authenticated/staff/$staffId': typeof AuthenticatedStaffStaffIdRoute
  '/certifications/public/$contactId': typeof CertificationsPublicContactIdRoute
  '/enroll/$courseId/$sessionId': typeof EnrollCourseIdSessionIdRoute
  '/_authenticated/applicator-profiles/': typeof AuthenticatedApplicatorProfilesIndexRoute
  '/_authenticated/calendar/': typeof AuthenticatedCalendarIndexRoute
  '/_authenticated/certification-definitions/': typeof AuthenticatedCertificationDefinitionsIndexRoute
  '/_authenticated/colors/': typeof AuthenticatedColorsIndexRoute
  '/_authenticated/company/': typeof AuthenticatedCompanyIndexRoute
  '/_authenticated/contacts/': typeof AuthenticatedContactsIndexRoute
  '/_authenticated/courses/': typeof AuthenticatedCoursesIndexRoute
  '/_authenticated/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/_authenticated/entities/': typeof AuthenticatedEntitiesIndexRoute
  '/_authenticated/fair-quote/': typeof AuthenticatedFairQuoteIndexRoute
  '/_authenticated/products/': typeof AuthenticatedProductsIndexRoute
  '/_authenticated/projects/': typeof AuthenticatedProjectsIndexRoute
  '/_authenticated/shop/': typeof AuthenticatedShopIndexRoute
  '/_authenticated/staff/': typeof AuthenticatedStaffIndexRoute
  '/_authenticated/teacher-dashboard/': typeof AuthenticatedTeacherDashboardIndexRoute
  '/_authenticated/user-management/': typeof AuthenticatedUserManagementIndexRoute
  '/_authenticated/company/staff/$staffId': typeof AuthenticatedCompanyStaffStaffIdRoute
  '/_authenticated/company/staff/': typeof AuthenticatedCompanyStaffIndexRoute
  '/_authenticated/fair-quote/$projectSlug/': typeof AuthenticatedFairQuoteProjectSlugIndexRoute
  '/_authenticated/projects/$projectSlug/': typeof AuthenticatedProjectsProjectSlugIndexRoute
  '/_authenticated/fair-quote/$projectSlug/sections/$sectionSlug': typeof AuthenticatedFairQuoteProjectSlugSectionsSectionSlugRoute
  '/_authenticated/projects/$projectSlug/sections/$sectionSlug': typeof AuthenticatedProjectsProjectSlugSectionsSectionSlugRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/company'
    | '/client-milestone/$token'
    | '/student-portal/$contactId'
    | '/verify/$code'
    | '/certification-levels/'
    | '/login/'
    | '/student-portal/'
    | '/applicator-profiles/$profileId'
    | '/company/milestones'
    | '/company/quote'
    | '/company/room-calculation'
    | '/company/task-gen'
    | '/contacts/$contactId'
    | '/courses/$courseId'
    | '/entities/$entityId'
    | '/fair-quote/$projectSlug'
    | '/products/$productId'
    | '/projects/$projectSlug'
    | '/shop/$productId'
    | '/staff/$staffId'
    | '/certifications/public/$contactId'
    | '/enroll/$courseId/$sessionId'
    | '/applicator-profiles/'
    | '/calendar/'
    | '/certification-definitions/'
    | '/colors/'
    | '/company/'
    | '/contacts/'
    | '/courses/'
    | '/dashboard/'
    | '/entities/'
    | '/fair-quote/'
    | '/products/'
    | '/projects/'
    | '/shop/'
    | '/staff/'
    | '/teacher-dashboard/'
    | '/user-management/'
    | '/company/staff/$staffId'
    | '/company/staff/'
    | '/fair-quote/$projectSlug/'
    | '/projects/$projectSlug/'
    | '/fair-quote/$projectSlug/sections/$sectionSlug'
    | '/projects/$projectSlug/sections/$sectionSlug'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/client-milestone/$token'
    | '/student-portal/$contactId'
    | '/verify/$code'
    | '/certification-levels'
    | '/login'
    | '/student-portal'
    | '/applicator-profiles/$profileId'
    | '/company/milestones'
    | '/company/quote'
    | '/company/room-calculation'
    | '/company/task-gen'
    | '/contacts/$contactId'
    | '/courses/$courseId'
    | '/entities/$entityId'
    | '/products/$productId'
    | '/shop/$productId'
    | '/staff/$staffId'
    | '/certifications/public/$contactId'
    | '/enroll/$courseId/$sessionId'
    | '/applicator-profiles'
    | '/calendar'
    | '/certification-definitions'
    | '/colors'
    | '/company'
    | '/contacts'
    | '/courses'
    | '/dashboard'
    | '/entities'
    | '/fair-quote'
    | '/products'
    | '/projects'
    | '/shop'
    | '/staff'
    | '/teacher-dashboard'
    | '/user-management'
    | '/company/staff/$staffId'
    | '/company/staff'
    | '/fair-quote/$projectSlug'
    | '/projects/$projectSlug'
    | '/fair-quote/$projectSlug/sections/$sectionSlug'
    | '/projects/$projectSlug/sections/$sectionSlug'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/_authenticated/company'
    | '/client-milestone/$token'
    | '/student-portal/$contactId'
    | '/verify/$code'
    | '/certification-levels/'
    | '/login/'
    | '/student-portal/'
    | '/_authenticated/applicator-profiles/$profileId'
    | '/_authenticated/company/milestones'
    | '/_authenticated/company/quote'
    | '/_authenticated/company/room-calculation'
    | '/_authenticated/company/task-gen'
    | '/_authenticated/contacts/$contactId'
    | '/_authenticated/courses/$courseId'
    | '/_authenticated/entities/$entityId'
    | '/_authenticated/fair-quote/$projectSlug'
    | '/_authenticated/products/$productId'
    | '/_authenticated/projects/$projectSlug'
    | '/_authenticated/shop/$productId'
    | '/_authenticated/staff/$staffId'
    | '/certifications/public/$contactId'
    | '/enroll/$courseId/$sessionId'
    | '/_authenticated/applicator-profiles/'
    | '/_authenticated/calendar/'
    | '/_authenticated/certification-definitions/'
    | '/_authenticated/colors/'
    | '/_authenticated/company/'
    | '/_authenticated/contacts/'
    | '/_authenticated/courses/'
    | '/_authenticated/dashboard/'
    | '/_authenticated/entities/'
    | '/_authenticated/fair-quote/'
    | '/_authenticated/products/'
    | '/_authenticated/projects/'
    | '/_authenticated/shop/'
    | '/_authenticated/staff/'
    | '/_authenticated/teacher-dashboard/'
    | '/_authenticated/user-management/'
    | '/_authenticated/company/staff/$staffId'
    | '/_authenticated/company/staff/'
    | '/_authenticated/fair-quote/$projectSlug/'
    | '/_authenticated/projects/$projectSlug/'
    | '/_authenticated/fair-quote/$projectSlug/sections/$sectionSlug'
    | '/_authenticated/projects/$projectSlug/sections/$sectionSlug'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  ClientMilestoneTokenRoute: typeof ClientMilestoneTokenRoute
  StudentPortalContactIdRoute: typeof StudentPortalContactIdRoute
  VerifyCodeRoute: typeof VerifyCodeRoute
  CertificationLevelsIndexRoute: typeof CertificationLevelsIndexRoute
  LoginIndexRoute: typeof LoginIndexRoute
  StudentPortalIndexRoute: typeof StudentPortalIndexRoute
  CertificationsPublicContactIdRoute: typeof CertificationsPublicContactIdRoute
  EnrollCourseIdSessionIdRoute: typeof EnrollCourseIdSessionIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/student-portal/': {
      id: '/student-portal/'
      path: '/student-portal'
      fullPath: '/student-portal/'
      preLoaderRoute: typeof StudentPortalIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/certification-levels/': {
      id: '/certification-levels/'
      path: '/certification-levels'
      fullPath: '/certification-levels/'
      preLoaderRoute: typeof CertificationLevelsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify/$code': {
      id: '/verify/$code'
      path: '/verify/$code'
      fullPath: '/verify/$code'
      preLoaderRoute: typeof VerifyCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/student-portal/$contactId': {
      id: '/student-portal/$contactId'
      path: '/student-portal/$contactId'
      fullPath: '/student-portal/$contactId'
      preLoaderRoute: typeof StudentPortalContactIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/client-milestone/$token': {
      id: '/client-milestone/$token'
      path: '/client-milestone/$token'
      fullPath: '/client-milestone/$token'
      preLoaderRoute: typeof ClientMilestoneTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/company': {
      id: '/_authenticated/company'
      path: '/company'
      fullPath: '/company'
      preLoaderRoute: typeof AuthenticatedCompanyRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/user-management/': {
      id: '/_authenticated/user-management/'
      path: '/user-management'
      fullPath: '/user-management/'
      preLoaderRoute: typeof AuthenticatedUserManagementIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/teacher-dashboard/': {
      id: '/_authenticated/teacher-dashboard/'
      path: '/teacher-dashboard'
      fullPath: '/teacher-dashboard/'
      preLoaderRoute: typeof AuthenticatedTeacherDashboardIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/staff/': {
      id: '/_authenticated/staff/'
      path: '/staff'
      fullPath: '/staff/'
      preLoaderRoute: typeof AuthenticatedStaffIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/shop/': {
      id: '/_authenticated/shop/'
      path: '/shop'
      fullPath: '/shop/'
      preLoaderRoute: typeof AuthenticatedShopIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/projects/': {
      id: '/_authenticated/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AuthenticatedProjectsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/products/': {
      id: '/_authenticated/products/'
      path: '/products'
      fullPath: '/products/'
      preLoaderRoute: typeof AuthenticatedProductsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/fair-quote/': {
      id: '/_authenticated/fair-quote/'
      path: '/fair-quote'
      fullPath: '/fair-quote/'
      preLoaderRoute: typeof AuthenticatedFairQuoteIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/entities/': {
      id: '/_authenticated/entities/'
      path: '/entities'
      fullPath: '/entities/'
      preLoaderRoute: typeof AuthenticatedEntitiesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard/': {
      id: '/_authenticated/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AuthenticatedDashboardIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/courses/': {
      id: '/_authenticated/courses/'
      path: '/courses'
      fullPath: '/courses/'
      preLoaderRoute: typeof AuthenticatedCoursesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/contacts/': {
      id: '/_authenticated/contacts/'
      path: '/contacts'
      fullPath: '/contacts/'
      preLoaderRoute: typeof AuthenticatedContactsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/company/': {
      id: '/_authenticated/company/'
      path: '/'
      fullPath: '/company/'
      preLoaderRoute: typeof AuthenticatedCompanyIndexRouteImport
      parentRoute: typeof AuthenticatedCompanyRouteRoute
    }
    '/_authenticated/colors/': {
      id: '/_authenticated/colors/'
      path: '/colors'
      fullPath: '/colors/'
      preLoaderRoute: typeof AuthenticatedColorsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/certification-definitions/': {
      id: '/_authenticated/certification-definitions/'
      path: '/certification-definitions'
      fullPath: '/certification-definitions/'
      preLoaderRoute: typeof AuthenticatedCertificationDefinitionsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/calendar/': {
      id: '/_authenticated/calendar/'
      path: '/calendar'
      fullPath: '/calendar/'
      preLoaderRoute: typeof AuthenticatedCalendarIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/applicator-profiles/': {
      id: '/_authenticated/applicator-profiles/'
      path: '/applicator-profiles'
      fullPath: '/applicator-profiles/'
      preLoaderRoute: typeof AuthenticatedApplicatorProfilesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/enroll/$courseId/$sessionId': {
      id: '/enroll/$courseId/$sessionId'
      path: '/enroll/$courseId/$sessionId'
      fullPath: '/enroll/$courseId/$sessionId'
      preLoaderRoute: typeof EnrollCourseIdSessionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/certifications/public/$contactId': {
      id: '/certifications/public/$contactId'
      path: '/certifications/public/$contactId'
      fullPath: '/certifications/public/$contactId'
      preLoaderRoute: typeof CertificationsPublicContactIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/staff/$staffId': {
      id: '/_authenticated/staff/$staffId'
      path: '/staff/$staffId'
      fullPath: '/staff/$staffId'
      preLoaderRoute: typeof AuthenticatedStaffStaffIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/shop/$productId': {
      id: '/_authenticated/shop/$productId'
      path: '/shop/$productId'
      fullPath: '/shop/$productId'
      preLoaderRoute: typeof AuthenticatedShopProductIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/projects/$projectSlug': {
      id: '/_authenticated/projects/$projectSlug'
      path: '/projects/$projectSlug'
      fullPath: '/projects/$projectSlug'
      preLoaderRoute: typeof AuthenticatedProjectsProjectSlugRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/products/$productId': {
      id: '/_authenticated/products/$productId'
      path: '/products/$productId'
      fullPath: '/products/$productId'
      preLoaderRoute: typeof AuthenticatedProductsProductIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/fair-quote/$projectSlug': {
      id: '/_authenticated/fair-quote/$projectSlug'
      path: '/fair-quote/$projectSlug'
      fullPath: '/fair-quote/$projectSlug'
      preLoaderRoute: typeof AuthenticatedFairQuoteProjectSlugRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/entities/$entityId': {
      id: '/_authenticated/entities/$entityId'
      path: '/entities/$entityId'
      fullPath: '/entities/$entityId'
      preLoaderRoute: typeof AuthenticatedEntitiesEntityIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/courses/$courseId': {
      id: '/_authenticated/courses/$courseId'
      path: '/courses/$courseId'
      fullPath: '/courses/$courseId'
      preLoaderRoute: typeof AuthenticatedCoursesCourseIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/contacts/$contactId': {
      id: '/_authenticated/contacts/$contactId'
      path: '/contacts/$contactId'
      fullPath: '/contacts/$contactId'
      preLoaderRoute: typeof AuthenticatedContactsContactIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/company/task-gen': {
      id: '/_authenticated/company/task-gen'
      path: '/task-gen'
      fullPath: '/company/task-gen'
      preLoaderRoute: typeof AuthenticatedCompanyTaskGenRouteImport
      parentRoute: typeof AuthenticatedCompanyRouteRoute
    }
    '/_authenticated/company/room-calculation': {
      id: '/_authenticated/company/room-calculation'
      path: '/room-calculation'
      fullPath: '/company/room-calculation'
      preLoaderRoute: typeof AuthenticatedCompanyRoomCalculationRouteImport
      parentRoute: typeof AuthenticatedCompanyRouteRoute
    }
    '/_authenticated/company/quote': {
      id: '/_authenticated/company/quote'
      path: '/quote'
      fullPath: '/company/quote'
      preLoaderRoute: typeof AuthenticatedCompanyQuoteRouteImport
      parentRoute: typeof AuthenticatedCompanyRouteRoute
    }
    '/_authenticated/company/milestones': {
      id: '/_authenticated/company/milestones'
      path: '/milestones'
      fullPath: '/company/milestones'
      preLoaderRoute: typeof AuthenticatedCompanyMilestonesRouteImport
      parentRoute: typeof AuthenticatedCompanyRouteRoute
    }
    '/_authenticated/applicator-profiles/$profileId': {
      id: '/_authenticated/applicator-profiles/$profileId'
      path: '/applicator-profiles/$profileId'
      fullPath: '/applicator-profiles/$profileId'
      preLoaderRoute: typeof AuthenticatedApplicatorProfilesProfileIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/projects/$projectSlug/': {
      id: '/_authenticated/projects/$projectSlug/'
      path: '/'
      fullPath: '/projects/$projectSlug/'
      preLoaderRoute: typeof AuthenticatedProjectsProjectSlugIndexRouteImport
      parentRoute: typeof AuthenticatedProjectsProjectSlugRoute
    }
    '/_authenticated/fair-quote/$projectSlug/': {
      id: '/_authenticated/fair-quote/$projectSlug/'
      path: '/'
      fullPath: '/fair-quote/$projectSlug/'
      preLoaderRoute: typeof AuthenticatedFairQuoteProjectSlugIndexRouteImport
      parentRoute: typeof AuthenticatedFairQuoteProjectSlugRoute
    }
    '/_authenticated/company/staff/': {
      id: '/_authenticated/company/staff/'
      path: '/staff'
      fullPath: '/company/staff/'
      preLoaderRoute: typeof AuthenticatedCompanyStaffIndexRouteImport
      parentRoute: typeof AuthenticatedCompanyRouteRoute
    }
    '/_authenticated/company/staff/$staffId': {
      id: '/_authenticated/company/staff/$staffId'
      path: '/staff/$staffId'
      fullPath: '/company/staff/$staffId'
      preLoaderRoute: typeof AuthenticatedCompanyStaffStaffIdRouteImport
      parentRoute: typeof AuthenticatedCompanyRouteRoute
    }
    '/_authenticated/projects/$projectSlug/sections/$sectionSlug': {
      id: '/_authenticated/projects/$projectSlug/sections/$sectionSlug'
      path: '/sections/$sectionSlug'
      fullPath: '/projects/$projectSlug/sections/$sectionSlug'
      preLoaderRoute: typeof AuthenticatedProjectsProjectSlugSectionsSectionSlugRouteImport
      parentRoute: typeof AuthenticatedProjectsProjectSlugRoute
    }
    '/_authenticated/fair-quote/$projectSlug/sections/$sectionSlug': {
      id: '/_authenticated/fair-quote/$projectSlug/sections/$sectionSlug'
      path: '/sections/$sectionSlug'
      fullPath: '/fair-quote/$projectSlug/sections/$sectionSlug'
      preLoaderRoute: typeof AuthenticatedFairQuoteProjectSlugSectionsSectionSlugRouteImport
      parentRoute: typeof AuthenticatedFairQuoteProjectSlugRoute
    }
  }
}

interface AuthenticatedCompanyRouteRouteChildren {
  AuthenticatedCompanyMilestonesRoute: typeof AuthenticatedCompanyMilestonesRoute
  AuthenticatedCompanyQuoteRoute: typeof AuthenticatedCompanyQuoteRoute
  AuthenticatedCompanyRoomCalculationRoute: typeof AuthenticatedCompanyRoomCalculationRoute
  AuthenticatedCompanyTaskGenRoute: typeof AuthenticatedCompanyTaskGenRoute
  AuthenticatedCompanyIndexRoute: typeof AuthenticatedCompanyIndexRoute
  AuthenticatedCompanyStaffStaffIdRoute: typeof AuthenticatedCompanyStaffStaffIdRoute
  AuthenticatedCompanyStaffIndexRoute: typeof AuthenticatedCompanyStaffIndexRoute
}

const AuthenticatedCompanyRouteRouteChildren: AuthenticatedCompanyRouteRouteChildren =
  {
    AuthenticatedCompanyMilestonesRoute: AuthenticatedCompanyMilestonesRoute,
    AuthenticatedCompanyQuoteRoute: AuthenticatedCompanyQuoteRoute,
    AuthenticatedCompanyRoomCalculationRoute:
      AuthenticatedCompanyRoomCalculationRoute,
    AuthenticatedCompanyTaskGenRoute: AuthenticatedCompanyTaskGenRoute,
    AuthenticatedCompanyIndexRoute: AuthenticatedCompanyIndexRoute,
    AuthenticatedCompanyStaffStaffIdRoute:
      AuthenticatedCompanyStaffStaffIdRoute,
    AuthenticatedCompanyStaffIndexRoute: AuthenticatedCompanyStaffIndexRoute,
  }

const AuthenticatedCompanyRouteRouteWithChildren =
  AuthenticatedCompanyRouteRoute._addFileChildren(
    AuthenticatedCompanyRouteRouteChildren,
  )

interface AuthenticatedFairQuoteProjectSlugRouteChildren {
  AuthenticatedFairQuoteProjectSlugIndexRoute: typeof AuthenticatedFairQuoteProjectSlugIndexRoute
  AuthenticatedFairQuoteProjectSlugSectionsSectionSlugRoute: typeof AuthenticatedFairQuoteProjectSlugSectionsSectionSlugRoute
}

const AuthenticatedFairQuoteProjectSlugRouteChildren: AuthenticatedFairQuoteProjectSlugRouteChildren =
  {
    AuthenticatedFairQuoteProjectSlugIndexRoute:
      AuthenticatedFairQuoteProjectSlugIndexRoute,
    AuthenticatedFairQuoteProjectSlugSectionsSectionSlugRoute:
      AuthenticatedFairQuoteProjectSlugSectionsSectionSlugRoute,
  }

const AuthenticatedFairQuoteProjectSlugRouteWithChildren =
  AuthenticatedFairQuoteProjectSlugRoute._addFileChildren(
    AuthenticatedFairQuoteProjectSlugRouteChildren,
  )

interface AuthenticatedProjectsProjectSlugRouteChildren {
  AuthenticatedProjectsProjectSlugIndexRoute: typeof AuthenticatedProjectsProjectSlugIndexRoute
  AuthenticatedProjectsProjectSlugSectionsSectionSlugRoute: typeof AuthenticatedProjectsProjectSlugSectionsSectionSlugRoute
}

const AuthenticatedProjectsProjectSlugRouteChildren: AuthenticatedProjectsProjectSlugRouteChildren =
  {
    AuthenticatedProjectsProjectSlugIndexRoute:
      AuthenticatedProjectsProjectSlugIndexRoute,
    AuthenticatedProjectsProjectSlugSectionsSectionSlugRoute:
      AuthenticatedProjectsProjectSlugSectionsSectionSlugRoute,
  }

const AuthenticatedProjectsProjectSlugRouteWithChildren =
  AuthenticatedProjectsProjectSlugRoute._addFileChildren(
    AuthenticatedProjectsProjectSlugRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedCompanyRouteRoute: typeof AuthenticatedCompanyRouteRouteWithChildren
  AuthenticatedApplicatorProfilesProfileIdRoute: typeof AuthenticatedApplicatorProfilesProfileIdRoute
  AuthenticatedContactsContactIdRoute: typeof AuthenticatedContactsContactIdRoute
  AuthenticatedCoursesCourseIdRoute: typeof AuthenticatedCoursesCourseIdRoute
  AuthenticatedEntitiesEntityIdRoute: typeof AuthenticatedEntitiesEntityIdRoute
  AuthenticatedFairQuoteProjectSlugRoute: typeof AuthenticatedFairQuoteProjectSlugRouteWithChildren
  AuthenticatedProductsProductIdRoute: typeof AuthenticatedProductsProductIdRoute
  AuthenticatedProjectsProjectSlugRoute: typeof AuthenticatedProjectsProjectSlugRouteWithChildren
  AuthenticatedShopProductIdRoute: typeof AuthenticatedShopProductIdRoute
  AuthenticatedStaffStaffIdRoute: typeof AuthenticatedStaffStaffIdRoute
  AuthenticatedApplicatorProfilesIndexRoute: typeof AuthenticatedApplicatorProfilesIndexRoute
  AuthenticatedCalendarIndexRoute: typeof AuthenticatedCalendarIndexRoute
  AuthenticatedCertificationDefinitionsIndexRoute: typeof AuthenticatedCertificationDefinitionsIndexRoute
  AuthenticatedColorsIndexRoute: typeof AuthenticatedColorsIndexRoute
  AuthenticatedContactsIndexRoute: typeof AuthenticatedContactsIndexRoute
  AuthenticatedCoursesIndexRoute: typeof AuthenticatedCoursesIndexRoute
  AuthenticatedDashboardIndexRoute: typeof AuthenticatedDashboardIndexRoute
  AuthenticatedEntitiesIndexRoute: typeof AuthenticatedEntitiesIndexRoute
  AuthenticatedFairQuoteIndexRoute: typeof AuthenticatedFairQuoteIndexRoute
  AuthenticatedProductsIndexRoute: typeof AuthenticatedProductsIndexRoute
  AuthenticatedProjectsIndexRoute: typeof AuthenticatedProjectsIndexRoute
  AuthenticatedShopIndexRoute: typeof AuthenticatedShopIndexRoute
  AuthenticatedStaffIndexRoute: typeof AuthenticatedStaffIndexRoute
  AuthenticatedTeacherDashboardIndexRoute: typeof AuthenticatedTeacherDashboardIndexRoute
  AuthenticatedUserManagementIndexRoute: typeof AuthenticatedUserManagementIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedCompanyRouteRoute: AuthenticatedCompanyRouteRouteWithChildren,
  AuthenticatedApplicatorProfilesProfileIdRoute:
    AuthenticatedApplicatorProfilesProfileIdRoute,
  AuthenticatedContactsContactIdRoute: AuthenticatedContactsContactIdRoute,
  AuthenticatedCoursesCourseIdRoute: AuthenticatedCoursesCourseIdRoute,
  AuthenticatedEntitiesEntityIdRoute: AuthenticatedEntitiesEntityIdRoute,
  AuthenticatedFairQuoteProjectSlugRoute:
    AuthenticatedFairQuoteProjectSlugRouteWithChildren,
  AuthenticatedProductsProductIdRoute: AuthenticatedProductsProductIdRoute,
  AuthenticatedProjectsProjectSlugRoute:
    AuthenticatedProjectsProjectSlugRouteWithChildren,
  AuthenticatedShopProductIdRoute: AuthenticatedShopProductIdRoute,
  AuthenticatedStaffStaffIdRoute: AuthenticatedStaffStaffIdRoute,
  AuthenticatedApplicatorProfilesIndexRoute:
    AuthenticatedApplicatorProfilesIndexRoute,
  AuthenticatedCalendarIndexRoute: AuthenticatedCalendarIndexRoute,
  AuthenticatedCertificationDefinitionsIndexRoute:
    AuthenticatedCertificationDefinitionsIndexRoute,
  AuthenticatedColorsIndexRoute: AuthenticatedColorsIndexRoute,
  AuthenticatedContactsIndexRoute: AuthenticatedContactsIndexRoute,
  AuthenticatedCoursesIndexRoute: AuthenticatedCoursesIndexRoute,
  AuthenticatedDashboardIndexRoute: AuthenticatedDashboardIndexRoute,
  AuthenticatedEntitiesIndexRoute: AuthenticatedEntitiesIndexRoute,
  AuthenticatedFairQuoteIndexRoute: AuthenticatedFairQuoteIndexRoute,
  AuthenticatedProductsIndexRoute: AuthenticatedProductsIndexRoute,
  AuthenticatedProjectsIndexRoute: AuthenticatedProjectsIndexRoute,
  AuthenticatedShopIndexRoute: AuthenticatedShopIndexRoute,
  AuthenticatedStaffIndexRoute: AuthenticatedStaffIndexRoute,
  AuthenticatedTeacherDashboardIndexRoute:
    AuthenticatedTeacherDashboardIndexRoute,
  AuthenticatedUserManagementIndexRoute: AuthenticatedUserManagementIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  ClientMilestoneTokenRoute: ClientMilestoneTokenRoute,
  StudentPortalContactIdRoute: StudentPortalContactIdRoute,
  VerifyCodeRoute: VerifyCodeRoute,
  CertificationLevelsIndexRoute: CertificationLevelsIndexRoute,
  LoginIndexRoute: LoginIndexRoute,
  StudentPortalIndexRoute: StudentPortalIndexRoute,
  CertificationsPublicContactIdRoute: CertificationsPublicContactIdRoute,
  EnrollCourseIdSessionIdRoute: EnrollCourseIdSessionIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
